import { pick, parse, stringify } from 'query-string'
import { FilterQueryParam } from '../search/filter-query-param-util/query-params'
import { SavedSearch } from '../../patterns/saved-searches/save-search'

const validQueryParams: FilterQueryParam[] = Object.values(FilterQueryParam).filter(
    (value) =>
        value !== FilterQueryParam.page &&
        value !== FilterQueryParam.advertising_location &&
        value !== FilterQueryParam.include_delivery_option
)

export const urlToParams = (url: string): string[][] => {
    // Extract query strings
    const queryString = url.split('?')[1] || ''
    if (queryString === '') {
        return []
    }

    // Split into key-value pairs
    return queryString
        .split('&')
        .map((param) => param.split('='))
        .filter(([key]) => key !== 'saved-search-id')
        .sort()
}

export const cleanUrl = (userSearchUrl: string) => {
    const urlExcludingQueryString = userSearchUrl.split('?')[0] || ''
    const queryString = userSearchUrl.split('?')[1] || ''
    const parsedQueryString = parse(queryString)
    const cleanedQueryString = stringify(parsedQueryString, { arrayFormat: 'none', encode: true })
    return pick(urlExcludingQueryString + '?' + cleanedQueryString, validQueryParams, { encode: true })
}

export const isASavedSearch = (savedSearchList: ReadonlyArray<SavedSearch>, userSearchUrl: string): boolean => {
    const cleanedUserSearchUrl = cleanUrl(userSearchUrl)
    const currentSearchParams = urlToParams(cleanedUserSearchUrl)
    const currentSearchParamsString = JSON.stringify(currentSearchParams)
    const currentSearchParamsWithoutSortString = JSON.stringify(
        urlToParams(cleanedUserSearchUrl).filter(([key]) => key !== 'sort')
    )

    const foundSavedSearch = savedSearchList.find((savedSearch) => {
        const savedSearchParams = urlToParams(savedSearch.searchCriteria)
        const savedSearchParamsIncludesSort = savedSearchParams.some(([key]) => key === 'sort')
        const savedSearchParamsString = JSON.stringify(savedSearchParams)

        if (savedSearchParamsIncludesSort) {
            return currentSearchParamsString === savedSearchParamsString
        } else {
            return currentSearchParamsWithoutSortString === savedSearchParamsString
        }
    })
    return !!foundSavedSearch
}
